<template>
  <v-dialog v-model="dialogShow" persistent width="900" class="dialog">
    <v-card>
      <v-card-title class="dialogTitle">
        <p class="dialogTitle-title">打开文件</p>
        <v-spacer></v-spacer>
        <p @click="closeDialog" class="dialogTitle-close iconfontFamily">&#xe60d;</p>
      </v-card-title>
      <v-card-text style="height:582px;padding:0;font-size:14px;color:#000000;">
        <div style="width:120px;height:100%;border-right:1px solid #e5e5e5;padding-top:20px;float:left;">
          <div @click="clickTabItem(item)" v-for="(item,index) in tabList" :key="index" class="tabItem"
               :style="{'background':currTab===item ? 'rgba(42, 130, 228, 0.2)' : '','color':currTab===item ? '#1976D2' : '#000000'}">
            <p style="line-height:37px;margin-left:20px;">{{item}}</p>
          </div>
        </div>
        <div style="width:calc(100% - 120px);height:100%;float:right;">

          <!--我的文件-->
          <div v-show="currTab === '我的文件'" style="padding-top:9px;">
            <div style="border-bottom:1px solid #e5e5e5;font-weight:bold;display:flex;">
              <p style="padding-left:134px;line-height:42px;flex:1;">文件名</p>
              <p style="width:327px;padding-left:107px;line-height:42px;">更新时间</p>
            </div>
            <div style="height:440px;padding:0 30px;">
              <div @click="currChooseFolderId = item.fileId" v-for="(item,index) in myFolderInfo.folderList" :key="index"
                   :style="{'background':currChooseFolderId === item.fileId ? 'rgba(42, 130, 228, 0.2)' : ''}" class="folderListItem">
                <p :style="{'visibility':item.fileId === $store.state.currFolderId ? 'visible' : 'hidden'}" style="margin-left:11px;line-height:46px;color:#2A82E4;">编辑中</p>
                <p style="padding-left:27px;line-height:46px;flex:1;overflow: hidden;text-overflow:ellipsis;white-space: nowrap;">{{item.fileName}}</p>
                <p style="width:297px;padding-left:100px;line-height:46px;">{{item.gmtModifytime.slice(0,10)}}</p>
              </div>
            </div>
            <div style="margin-top:26px;padding:0 30px;display:flex;align-items:center;">
              <v-spacer></v-spacer>
              <!--页码-->
              <page-number v-show="myFolderInfo.totalPageNum > 1" :totalPageNum="myFolderInfo.totalPageNum" :currPageNum="myFolderInfo.currPageNum" @changePageNumber="getMyFolderList"></page-number>
              <v-spacer></v-spacer>
              <v-btn @click="chooseFolder" width="100" height="35" dark :color="currChooseFolderId!==''&&currChooseFolderId!==$store.state.currFolderId ? '#1E3A8A' : 'rgba(30, 58, 138, 0.5)'">打开</v-btn>
            </div>
          </div>


          <!--本地文件-->
          <div v-show="currTab === '本地文件'" style="padding:21px 26px;">
            <div v-show="!fileUploading && !fileUploadError">
              <div style="position:relative;width:110px;height:35px;">
                <v-btn width="110" height="35" dark color="#2A82E4">
                  <span style="margin-top:3px;margin-right:8px;" class="iconfontFamily">&#xe64c;</span>文件上传
                </v-btn>
                <input ref="uploadFileInput" @change="uploadFile()" type="file" style="position:absolute;top:0;left:0;width:100%;height:100%;opacity:0;cursor:pointer;">
              </div>
              <p style="margin-top:25px;font-size:16px;">矢量文件上传功能，支持本地KML、KMZ、ZIP（需包含.shp、.shx、.dbf和.prj）格式文件上传</p>
              <p style="margin-top:9px;color:#808080">注：KML、KMZ文件默认坐标系是WGS84（即GPS坐标系）、SHP文件默认坐标系是GCJ02（即火星坐标系）</p>
            </div>

            <!--解析中-->
            <div v-show="fileUploading" style="text-align:center;">
              <p style="margin-top:243px;font-size:20px;">数据解析中...</p>
            </div>

            <!--解析错误-->
            <div v-show="fileUploadError" style="text-align:center;">
              <p style="margin-top:243px;font-size:20px;">解析失败</p>
              <v-btn @click="fileUploadError = false" width="80" height="35" dark color="#2A82E4" style="margin-top:190px;">返回</v-btn>
            </div>


          </div>




        </div>

      </v-card-text>
    </v-card>



    <v-dialog v-model="oldFolderCloseDialogShow" persistent max-width="540">
      <v-card>
        <v-card-title class="tipsDialog-title">
          温馨提示
          <v-spacer></v-spacer>
          <p @click="oldFolderCloseDialogShow = false" class="tipsDialog-close iconfontFamily">&#xe60d;</p>
        </v-card-title>
        <v-card-text class="tipsDialog-mainArea">
          <div style="display:flex;align-items:center">
            <p class="tipsDialog-mainArea-icon iconfontFamily">&#xe627;</p>
            <p class="tipsDialog-mainArea-text">打开其他文件会失去当前未保存内容，是否继续？</p>
          </div>
          <div class="tipsDialog-mainArea-btnLine">
            <v-btn @click="oldFolderCloseDialogShow = false" width="100" height="35" color="#F5F5F5">取消</v-btn>
            <v-btn @click="oldFolderCloseOK" width="100" height="35" dark color="#1E3A8A" style="margin-left:50px;">确定</v-btn>
          </div>
        </v-card-text>
      </v-card>
    </v-dialog>



  </v-dialog>
</template>

<script>
import PageNumber from '/src/components/page_number/PageNumber';

export default {
  name: "ChooseGlobeOperationFolder",
  components: {
    PageNumber
  },
  props:["dialogShow"],

  data(){
    return{

      currTab:"我的文件",
      tabList:[
          "我的文件","本地文件"
      ],

      currChooseFolderId:"",


      myFolderInfo:{
        folderList:[],
        totalPageNum:0,
        currPageNum:1,
      },


      fileUploading:false,
      fileUploadError:false,


      //离开旧文件夹弹窗
      oldFolderCloseDialogShow:false,





    }

  },
  methods:{
    closeDialog(){
      this.$emit("closeDialog","")
    },

    //选择左侧栏某项
    clickTabItem(item){
      this.currTab = item
    },


    //我的文件
    getMyFolderList(pageNum){
      this.$axios({
        method:"get",
        url:"/authorApi/z-geo-file/getFileList",
        params:{
          curPageNum:pageNum,
          maxResultNum:10,
        }
      }).then((resultData)=>{
        resultData = resultData.data;
        if(resultData.status === 200){
          this.myFolderInfo.currPageNum = pageNum
          this.myFolderInfo.folderList = resultData.data.list;
          this.myFolderInfo.totalPageNum = resultData.data.totalPageNum;
        }
        else{
          console.log(resultData.status + resultData.message);
        }
      }).catch((err)=>{
        console.log(err);
      });

    },

    //确定选择文件夹
    chooseFolder(){
      if(this.currChooseFolderId!=='' && this.currChooseFolderId!==this.$store.state.currFolderId){
        //选择了要打开的文件
        if(this.$store.state.globeQuitShowDialog){
          this.oldFolderCloseDialogShow = true;
        }
        else{
          this.$emit("chooseFolderOk",this.currChooseFolderId)
        }
      }
    },
    oldFolderCloseOK(){
      this.oldFolderCloseDialogShow = false;
      this.$emit("chooseFolderOk",this.currChooseFolderId)
    },



    //本地文件上传     补充：权限判断
    uploadFile(){
      if(this.$store.state.currFolderTeamReadonly === 1 && this.$store.state.currFolderRole !==1){
        this.$store.state.snackbarShow=true
        this.$store.state.snackbarText = "暂无权限，请联系创建者"
        this.$store.state.snackbarType = 'error'
      }else{
        this.uploadFile1()
      }
    },
    uploadFile1(){
      let file = this.$refs.uploadFileInput.files[0];
      let filename = this.omitName(file.name);
      console.log(filename)
      if(filename.slice(-3) === "kml" || filename.slice(-3) === "kmz" || filename.slice(-3) === "zip") {
        this.fileUploading = true;
        let paramData = new FormData();
        paramData.append('multipartFile',file);
        paramData.append('fileId',this.$store.state.currFolderId);
        this.$axios.post('/authorApi/z-geo-file/fileImport',paramData)
            .then((resultData)=>{
              resultData = resultData.data;
              console.log(resultData)
              if(resultData.status === 200){
                this.$emit("chooseFolderUploadFileOk",JSON.stringify(resultData.data.content))
                this.$refs.uploadFileInput.value = '';
                this.fileUploading = false;
              }else{
                console.log(resultData.status + resultData.message);
                this.$refs.uploadFileInput.value = '';
                this.fileUploading = false;
                this.fileUploadError = true;
              }
            })
            .catch(()=>{
              this.$refs.uploadFileInput.value = '';
              this.fileUploading = false;
              this.fileUploadError = true;
            })
      }
      else{
        this.$emit("chooseFolderUploadFileError","")
      }

    },




    omitName (str) {
      var realLength = 0, len = str.length, charCode = -1;
      for (var i = 0; i < len; i++) {
        charCode = str.charCodeAt(i);
        if (charCode >= 0 && charCode <= 128) realLength += 1;
        else realLength += 2;
      }
      if (realLength > 12) {
        return str.substring(0, 10) + "...zip"
      }
      else
        return str
    },





  },
  mounted(){
    this.getMyFolderList(1);

  }

}
</script>

<style scoped>

.tabItem{
  width:100%;
  height:37px;
  cursor:pointer;
}
.tabItem:hover{
  background:rgba(42, 130, 228, 0.2);
  color:#1976D2
}


.folderListItem{
  height:44px;
  border-bottom:1px solid #e5e5e5;
  display:flex;
  cursor:pointer;
}
.folderListItem:hover{
  background:rgba(42, 130, 228, 0.2);
}



</style>
